<template>
  <div v-if="!groupID">
    <div class="container py-5">
      <!-- Header Section -->
      <div class="text-center mb-4">
        <h2><strong>MEET OUR <span class="text-dark">TEAM</span></strong></h2>
        <p class="text-muted">
          Hello everyone,
          <br /><br />
          We’re excited to announce that the <strong>new Hextar Team Directory</strong> is officially launching!
          This directory highlights all our amazing team members across every department, division, and region
          within the
          Hextar Group.
          <br /><br />
          With over <strong>2,000 employees</strong> and growing, this platform is designed to help you:
        <ul>
          <li>Easily find colleagues across different subsidiaries</li>
          <li>Understand reporting structures and team responsibilities</li>
          <li>Explore the diversity of roles within our organization</li>
        </ul>
        This is part of our commitment to building a more connected, transparent, and people-first culture.
        <br /><br />
        We hope this helps foster collaboration, encourage cross-team discovery, and strengthen the Hextar family
        spirit.
        <br /><br />
        Let’s grow together — and yes, the directory may even feature a few surprise fun facts 😉.
        </p>
      </div>

      <!-- Filter Dropdown -->
      <div class="mb-4" style="position: relative;" v-if="!groupID">
        <multiselect v-model="companyID" track-by="value" label="text" placeholder="Select one" :options="companyDdl"
          @input="filterByCompany" :searchable="true" :allow-empty="true" class="w-100" />

        <!-- Clear icon -->
        <span v-if="companyID != null" class="text-danger" @click="removeCompanyValue"
          style="position: absolute; top: 50%; right: 12px; transform: translateY(-50%); cursor: pointer; font-size: 18px;">
          &#10006;
        </span>
      </div>

      <div>
        <b-row>
          <b-col v-for="member in tableRows" :key="member.id" cols="12" md="6" lg="4" class="d-flex">
            <b-card class="hover-card flex-fill d-flex flex-column text-center border-0 bg-transparent shadow-none">
              <b-avatar :src="member.image" size="120px" rounded class="mb-3 mx-auto member-avatar" />
              <div>
                <h5 class="mb-1 font-weight-bold" v-if="member.chineseName"
                  style="font-size: 1.4rem; color: black; font-weight: bold;">
                  <b> {{ member.chineseName }} </b>
                </h5>
                <p class="mb-1 text-muted" style="font-size: 1.1rem; color: black; font-weight: bold;">
                  <b>{{ member.firstName + " " + member.lastName }}</b>
                </p>
              </div>
              <div class="flex-grow-1"></div>
              <div class="mt-12">
                <div class="d-inline-block" v-b-tooltip.hover title="Chat on WhatsApp">
                  <i v-if="member.phone && member.phone != 'null' && member.phone != '0' && member.phone != 0"
                    class="mdi mdi-whatsapp cursor-pointer text-success ml-2" style="font-size: 30px;"
                    @click="sendWhatsapp(member.phone)"></i>
                </div>

                <div class="d-inline-block" v-b-tooltip.hover title="Send Email">
                  <i v-if="member.email" class="mdi mdi-email cursor-pointer ml-2"
                    style="font-size: 30px; color: #00B4F0;"
                    @click="sendMail(member.phone)"></i>
                </div>

                <div class="d-inline-block" v-b-tooltip.hover title="Call Phone">
                  <i v-if="member.phone && member.phone != 'null' && member.phone != '0' && member.phone != 0"
                    class="mdi mdi-phone cursor-pointer ml-2" style="font-size: 30px; color: #00B4F0;"
                    @click="callPhone(member.phone)"></i>
                </div>

                <div class="d-inline-block" v-b-tooltip.hover title="Add to Address Book">
                  <i class="mdi mdi-account-plus cursor-pointer ml-2" style="font-size: 30px; color: #00B4F0;"
                    @click="downloadVCard(member)"></i>
                </div>
              </div>
               <div class="mt-12">
                <button class="btn btn-primary btn-sm" @click="redirectToDetailsPage(member.id)">
                View More
              </button>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <div class="row mt-4">
          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-right">
              <b-pagination v-model="currentPage" :total-rows="pagination.total" :per-page="pagination.perPage"
                @change="pageNavigation" size="md" class="pagination pagination-rounded mb-0"></b-pagination>
            </div>
          </div>
        </div>
      </div>

    </div>
    <Footer></Footer>

  </div>
  <div style="background-color: white;" v-else>

    <!-- New Centered Image Header Section -->
    <div class="header-image-banner text-center">
      <div style="padding-top: 10px; padding-bottom: 10px;">
        <img src="https://ihextar.s3.ap-southeast-1.amazonaws.com/CO_Final_40th+Anniversary_Logo.png" alt="Header Image"
          class="img-fluid mx-auto d-block" style="max-height: 150px;">
      </div>
    </div>
    <div class="py-5">
      <div class="container">
        <div class="row g-4">
          <div class="col-6 col-md-4 col-lg-2" v-for="(label, i) in images" :key="i">
            <div class="position-relative image-overlay-card">
              <img :src="`https://hextargroup.com/wp-content/uploads/2024/04/0${i + 1}.jpg`" class="img-fluid"
                :alt="label.title" />
              <div class="overlay-content text-white d-flex flex-column justify-content-center text-center p-3">
                <h6 class="text-white">
                  <span class="first-letter">{{ label.title.charAt(0) }}</span>{{ label.title.slice(1) }}
                </h6>
                <p class="small mb-0">{{ label.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Content Section -->
    <div class="leaders-section py-5">
      <div class="container">
        <h2 class="fw-bold text-white mb-4" style="text-align: center;">Meet Our Leaders</h2>
      </div>
    </div>
    <div class="py-5 bg-white">
      <div class="container">
        <div class="row g-4" v-for="(companyData, companyIndex) in companyTableRows" :key="companyIndex">
          <div>
            <h2 class="fw-bold text-black mb-4 text-center">{{ companyData.name }}</h2>
            <!-- ✅ Add this wrapper row -->
            <div class="row g-4">
              <div class="" v-for="member in companyData.activeCompanyIhextarUser" :key="member.user.id">
                <div class="card border-0 shadow-sm h-100 text-center">
                  <img :src="member.user.image" :alt="member.user.first_name" class="card-img-top rounded-top" />
                  <div class="card-body">
                    <h6 class="fw-bold mb-1" v-if="member.user.chinese_name">
                      {{ member.user.chinese_name }}
                    </h6>
                    <h6 class="fw-bold mb-1">
                      {{ member.user.first_name + " " + member.user.last_name }}
                    </h6>
                    <p class="text-muted small mb-1">{{ member.position }}</p>
                    <p class="text-warning small mb-0 d-flex align-items-center justify-content-center">
                      <i class="mdi mdi-star text-warning me-1"></i> Featured Staff
                    </p>
                     <button class="btn btn-primary btn-sm" @click="redirectToDetailsPage(member.user.id)">
                View More
              </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import { LOOKUP_MODULE } from '@/state/modules/lookup'
import { USER_MODULE } from '@/state/modules/user'
import { lookupMethods, userMethods, companyMethods } from "@/state/helpers";
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
import { SESSION, SHARED } from "@/constants";
import { sessionHelper } from "@/utils";
import { COMPANY_MODULE } from '@/state/modules/company'
import Footer from "@/components/new-footer";

export default {
  components: { Multiselect, Footer },
  computed: {
    ...mapState(USER_MODULE),
    ...mapState(LOOKUP_MODULE),
    ...mapState(COMPANY_MODULE),

    companyDdl() {
      return this.$store.state.lookup.publicCompanyDdl;
    },
    tableRows() {
      return this.$store.state.user.list.data;
    },
    pagination() {
      return this.$store.state.user.list.pagination;
    },
    totalPage() {
      return this.$store.state.user.list.pagination.total;
    },
    companyTableRows() {
      console.log(this.$store.state.company.list.data)
      return this.$store.state.company.list.data;
    },
    companyPagination() {
      return this.$store.state.company.list.pagination;
    },
    companyTotalPage() {
      return this.$store.state.company.list.pagination.total;
    },
  },
  created() {
    this.initSearchCriteria();
    this.lookupPublicCompany({ hasOptionAll: false });
  },
  data() {
    return {
      groupID: this.$route.query.id,
      companyID: null,
      selectedFilter: null,
      currentPage: 1,
      images: [
        {
          title: "humility",
          description:
            "Fostering an environment of mutual respect which encourages appreciation and cooperation amongst each other with self-awareness and open mindedness to learn and grow",
        },
        {
          title: "excellence",
          description:
            "Pushing boundaries to achieve the highest possible standards of performance and quality",
        },
        {
          title: "x-factor",
          description:
            "Ability to think outside the box to develop unique solutions to complex challenges and to push past traditions with innovative and progressive ideas",
        },
        {
          title: "trustworthy",
          description:
            "Being honest and showing a consistent and uncompromising adherence to strong moral and ethical principles and values",
        },
        {
          title: "adaptability",
          description:
            "Ability to change and adjust to shifting demands and requirements by being proactive and resourceful",
        },
        {
          title: "responsibility",
          description:
            "Demonstrating reliability by staying true to the task, accepting accountability for your duties and carrying out the task to the best of your capabilities",
        },
      ],
    };
  },
  methods: {
    ...lookupMethods,
    ...userMethods,
    ...companyMethods,

    initSearchCriteria() {
      let isDefault = true;

      if (sessionHelper.hasSearchCriteria(SESSION.USER_SEARCH)) {
        isDefault = false;
        this.searchCriteria = sessionHelper.retrieveSearch(SESSION.USER_SEARCH);
      }

      if (isDefault) {
        this.searchCriteria = {
          pageNumber: SHARED.DEFAULT_PAGE_NUMBER,
          pageSize: SHARED.DEFAULT_PAGE_SIZE,
          searchValue: "",
          searchArray: [],
          groupID: this.groupID
        };
      }

      if (this.groupID) {
        this.searchCriteria.groupID = this.groupID;
        this.getAllCompanies({ filter: this.searchCriteria });
      }
      else {
        this.getAllUsers({ filter: this.searchCriteria });
        sessionHelper.storeSearch(SESSION.USER_SEARCH, this.searchCriteria);
      }
    },

    sendWhatsapp(phone) {
      if (phone.startsWith("6")) {
        phone = phone.substring(1);
      }

      var country_code_phone = "+6" + phone;
      var url = "https://wa.me/" + country_code_phone + "?text=Hi, I got your number from Hextar's catalog and wanted to reach out";
      window.open(url, "_blank");
    },

    callPhone(phone) {
      if (phone.startsWith("6")) {
        phone = phone.substring(1);
      }
      window.location.href = `tel:${phone}`;
    },

    sendMail(mail) {
      window.location.href = `mailto:${mail}`;
    },

    downloadVCard(member) {
      const fullName = `${member.firstName || ''} ${member.lastName || ''}`.trim();
      const vCardData = `
BEGIN:VCARD
VERSION:3.0
FN:${fullName}
N:${member.lastName || ''};${member.firstName || ''};;;
TEL;TYPE=CELL:${member.phone || ''}
EMAIL:${member.email || ''}
END:VCARD
    `.trim();

      const blob = new Blob([vCardData], { type: "text/vcard" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = `${fullName || "contact"}.vcf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },

    pageNavigation(pageNumber) {
      let filter = sessionHelper.retrieveSearch(SESSION.USER_SEARCH);
      filter.pageNumber = pageNumber;

      this.getAllUsers({ filter: filter });
    },

    redirectToDetailsPage(id) {
    const url = "/name-card?id=" + id;
  window.open(url, "_blank");

    },

    filterByCompany() {
      let filter = sessionHelper.retrieveSearch(SESSION.USER_SEARCH);
      filter.pageNumber = 1;
      filter.company = this.companyID.value;
      this.currentPage = 1;

      this.getAllUsers({ filter: filter });
    },

    removeCompanyValue() {
      this.companyID = null;
      let filter = sessionHelper.retrieveSearch(SESSION.USER_SEARCH);
      filter.pageNumber = 1;
      filter.company = this.companyID;
      this.currentPage = 1;

      this.getAllUsers({ filter: filter });
    }
  }
};
</script>

<style scoped>
a {
  color: #6c757d;
}

a:hover {
  color: #343a40;
}

.member-avatar {
  border: 4px solid #f5f5f5;
  transition: border-color 0.3s ease, transform 0.3s ease;
}

.hover-card:hover .member-avatar {
  border-color: #007bff;
  transform: scale(1.05);
  cursor: pointer;
}

.first-letter {
  font-weight: bold;
  text-transform: uppercase;
}

.leaders-section {
  background: linear-gradient(to bottom right, #0d0d0d, #333);
}

.form-select {
  border-radius: 10px;
  min-width: 260px;
  font-weight: 500;
}

.image-overlay-card {
  position: relative;
  height: 300px;
  overflow: hidden;
  border-radius: 10px;
}

.image-overlay-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.overlay-content {
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
}

.card-img-top {
  height: 150px;
  object-fit: cover;
  border-radius: 12px 12px 0 0;
}
</style>